import {Avatar, classNames} from '@/core'
import {useAdminEmployees} from '@u/drf/hooks'
import {doc} from './doc'
import styles from './style.module.styl'

const EmployeeCell = ({employee, onClickEmployee, active}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onClickEmployee(employee)}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClickEmployee(employee) } }}
      className={classNames(styles.employeeCell, active ? styles.active : '')}
    >
      <Avatar letter={employee.user.firstName[0]} src={employee.user.avatar} size='extraSmall' />
      <div>
        <h3>{!employee.user.firstName && employee.email}{employee.user.firstName} {employee.user.lastName} - {employee.company.name}</h3>
        <div className='stats'>
          <span>{employee.matchCount} {`match${employee.matchCount === 1 ? '' : 'es'}`}</span>
          <span>{employee.helpOfferedCount} {`offer${employee.helpOfferedCount === 1 ? '' : 's'}`}</span>
          <span>{employee.helpSuccessCount} {`success${employee.helpSuccessCount === 1 ? '' : 'es'}`}</span>
        </div>
      </div>
    </div>
  )
}

export const AdminEmployeeList = doc(
  ({}) => {
    const [employees] = useAdminEmployees()
    return (
      <div>
        {employees?.map(
          (e, i) => <EmployeeCell employee={e} active={i === 1} />
        )}
      </div>
    )
  }
)
